import Vue from 'vue'
import { Message } from 'element-ui';
Vue.prototype.$canUseBtn = function (params) {
    let btnArr = sessionStorage.getItem('btnAuth')
    return btnArr.includes(params)
};
Vue.prototype.$message_e = function (message){
   Message.error({
    message: message,
  })
}
Vue.prototype.$message_c = function (message){
      Message.success({
        message: message,
      })
}
// 手机号隐藏中间四位
Vue.prototype.$hidePhoneNumber = function (phoneNumber){
  return phoneNumber.replace(/(\d{3})\d{4}(\d{4})/, '\$1****\$2');
}

